import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CasesResumesService } from '../../_services/cases-resumes.service';
import { CaseResume } from '../../_types/case-resume';
import { CasesService } from '../../_services/cases.service';
import { CasesLogsService } from '../../_services/cases-logs.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-case-resume',
    templateUrl: './case-resume.component.html',
    styleUrls: ['./case-resume.component.scss'],
    standalone: false
})
export class CaseResumeComponent implements OnInit {

  public static readonly MIN_LOGS_FOR_RESUME = 50;

  public caseResume: CaseResume | null = null;
  public caseLogsCount: number = 0;
  public minLogsForResume = CaseResumeComponent.MIN_LOGS_FOR_RESUME;

  get hasEnoughLogs(): boolean {
    return this.caseLogsCount >= this.minLogsForResume;
  }

  constructor(
    private config: DynamicDialogConfig,
    public loginService: LoginService,
    private caseResumeService: CasesResumesService,
    private casesService: CasesService,
    private caseLogsService: CasesLogsService,
  ) {
  }

  async ngOnInit() {
    await this.loadData();
    await this.loadCaseLogsCount();
  }

  async loadCaseLogsCount() {
    let filter = {
      caseId: new Filter(FilterOperation.equals, 'caseId', '', this.config.data.id)
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.caseLogsService.all(params));
    this.caseLogsCount = response.meta['total'] ?? 0;
  }

  async loadData() {
    let filter = {
      caseId: new Filter(FilterOperation.equals, 'caseId', '', this.config.data.id)
    };
    let params:IParamsCollection = {
      include: ['createdByUser','updatedByUser'],
      /*fields: {
        user: 'name'
      },*/
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.caseResumeService.all(params));
    this.caseResume = null;
    if(response.data.length > 0) {
      this.caseResume = response.data[0];
    }
  }

  async resumeCaseNow() {
    await firstValueFrom(this.casesService.resume(this.config.data.id));
    await this.loadData();
  }

}
